import { Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import PeoplePage from './pages/PeoplePage';
import HappeningsPage from './pages/HappeningsPage';
import TasksPage from './pages/TasksPage';
import PlacesPage from './pages/PlacesPage';
import ProgramsPage from './pages/ProgramsPage';
import ProgramDetailPage from './pages/ProgramDetailPage';
import SelectionsPage from './pages/SelectionsPage';
import SelectionDetailPage from './pages/SelectionDetailPage';
import ThingsPage from './pages/ThingsPage';
import StaffRolesPage from './pages/StaffRolesPage';
import UsersPage from './pages/UsersPage';
import TemplatesPage from './pages/TemplatesPage';
import EmailTemplatesPage from './pages/EmailTemplatesPage';
import MediaManagerPage from './pages/MediaManagerPage';
import SocialCardsPage from './pages/SocialCardsPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import ApiKeysPage from './pages/ApiKeysPage';
import AuthEventsPage from './pages/AuthEventsPage';
import ArtistInvitePage from './pages/ArtistInvitePage';
import StaffSchedulePage from './pages/StaffSchedulePage';
import PublicTimetablePage from './pages/PublicTimetablePage';
import ShowInvitePage from './pages/ShowInvitePage';
import CombinedInvitePage from './pages/CombinedInvitePage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import LoginPage from './pages/LoginPage';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SentryRoutes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/people/:slug" element={<ArtistInvitePage />} />
        <Route path="/staff/:slug" element={<StaffSchedulePage />} />
        <Route path="/timetable/:programSlug" element={<PublicTimetablePage />} />
        <Route path="/shows/:slug" element={<ShowInvitePage />} />
        <Route path="/invite/:personSlug/:showSlug" element={<CombinedInvitePage />} />
        <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<HappeningsPage />} />
          <Route path="people" element={<PeoplePage />} />
          <Route path="happenings" element={<HappeningsPage />} />
          <Route path="tasks" element={<TasksPage />} />
          <Route path="places" element={<PlacesPage />} />
          <Route path="programs" element={<ProgramsPage />} />
          <Route path="programs/:id" element={<ProgramDetailPage />} />
          <Route path="selections" element={<SelectionsPage />} />
          <Route path="selections/:id" element={<SelectionDetailPage />} />
          <Route path="things" element={<ThingsPage />} />
          <Route path="staff-roles" element={<StaffRolesPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="email-templates" element={<EmailTemplatesPage />} />
          <Route path="media" element={<MediaManagerPage />} />
          <Route path="social-cards" element={<SocialCardsPage />} />
          <Route path="account" element={<AccountSettingsPage />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
          <Route path="auth-events" element={<AuthEventsPage />} />
        </Route>
      </SentryRoutes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
